import get from 'lodash/get';
import update from 'immutability-helper';
import { FETCH_PROFILE, FETCH_TOPIC_PROFILE } from 'src/common/actions/profile';
import createMappedReducer from './utils/createMappedReducer';
import createRequestLifecycleHandlers from './utils/createRequestLifecycleHandlers';
import createContainerNavigationHandlers from './utils/createContainerNavigationHandlers';
import { fulfilled } from './utils/asyncActionNameSuffixes';

export const profiles = createMappedReducer(
  {},
  {
    ...createContainerNavigationHandlers(),
    ...createRequestLifecycleHandlers({ fetchActionNameRoot: FETCH_PROFILE }),
    ...createRequestLifecycleHandlers({
      fetchActionNameRoot: FETCH_TOPIC_PROFILE,
    }),

    [fulfilled(FETCH_PROFILE)](state, action) {
      const { categoryToPrepend, contentId } = action.meta;
      const { content, loadedTime } = action.payload;

      if (categoryToPrepend) {
        const profileContainerItems = get(content, 'containerItems', []);
        profileContainerItems.unshift(categoryToPrepend);
      }

      return update(state, {
        [contentId]: {
          $merge: {
            ...content,
            loadedTime,
            isFetching: false,
          },
        },
      });
    },
  },
);
